import React from "react";
import { api, useApp, useAsync } from "../store.js";
import { OK, WARN, CRIT, ACC, UNK, PageHead, card, cardPad } from "../lib/ui.js";

export function Overview() {
  const { session, setView, canSee } = useApp();
  const leadOk = canSee("lead-distribution");
  const sum = useAsync(() => (leadOk ? api.leadDistSummary({}) : Promise.resolve(null)), [leadOk]);
  const src = useAsync(() => (leadOk ? api.leadDistSource() : Promise.resolve(null)), [leadOk]);
  const s = sum.data;

  const fmt = (n: number | undefined) => (n == null ? "—" : n.toLocaleString("en-US"));
  const pct = (n: number | undefined) => (n == null ? "—" : Math.round(n * 100) + "%");

  return (
    <div>
      <PageHead
        title={`Welcome, ${session?.name?.split(" ")[0] ?? ""}`.trim()}
        sub="Rever Analytics Dashboard Portal · access managed in code"
      />

      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(260px, 1fr))", gap: "10px" }}>
        {leadOk ? (
          <button onClick={() => setView("leaddist")} style={{ ...cardPad, display: "flex", flexDirection: "column", gap: "10px", cursor: "pointer", textAlign: "left", color: "inherit", font: "inherit", borderLeft: "2px solid " + ACC }}>
            <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
              <i className="ph ph-share-network" style={{ fontSize: "15px", color: ACC }} />
              <span style={{ fontSize: "13px", fontWeight: 500 }}>Lead Distribution</span>
              <i className="ph ph-arrow-up-right" style={{ marginLeft: "auto", fontSize: "12px", color: "#595d6c" }} />
            </div>
            <div style={{ display: "flex", gap: "16px", flexWrap: "wrap" }}>
              <Stat label="Received" value={fmt(s?.received)} c="#e9e9ed" />
              <Stat label="Assigned" value={fmt(s?.assigned)} c={OK} />
              <Stat label="Handled" value={fmt(s?.handled)} c={ACC} />
              <Stat label="Revoked" value={fmt(s?.revoked)} c={CRIT} />
            </div>
            <div style={{ fontSize: "11px", color: "#75798c" }}>
              Revoke rate {pct(s?.revokedRate)} · {src.data?.live ? <span style={{ color: OK }}>live data</span> : <span style={{ color: WARN }}>{src.data?.note ?? "sample data"}</span>}
            </div>
          </button>
        ) : (
          <div style={{ ...cardPad, color: UNK, fontSize: "12px" }}>
            You don't have access to any dashboards yet. Ask an admin to add you to the code access list.
          </div>
        )}

        <div style={{ ...cardPad, display: "flex", flexDirection: "column", gap: "6px", justifyContent: "center", color: "#595d6c" }}>
          <div style={{ display: "flex", alignItems: "center", gap: "8px", color: "#75798c" }}>
            <i className="ph ph-plus-circle" style={{ fontSize: "15px" }} />
            <span style={{ fontSize: "13px", fontWeight: 500 }}>More dashboards</span>
          </div>
          <div style={{ fontSize: "11px", lineHeight: 1.5 }}>Additional overview dashboards will appear here as they're added.</div>
        </div>
      </div>
    </div>
  );
}

function Stat({ label, value, c }: { label: string; value: string; c: string }) {
  return (
    <div>
      <div style={{ fontSize: "10px", letterSpacing: "0.07em", textTransform: "uppercase", color: "#9397ab" }}>{label}</div>
      <div style={{ fontFamily: "var(--font-heading)", fontSize: "21px", letterSpacing: "-0.02em", color: c, fontVariantNumeric: "tabular-nums" }}>{value}</div>
    </div>
  );
}
